module.exports = __webpack_public_path__ + "img/puente-facatativa.0dca0954.jpg";